<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'产品中心'"></navBox>
			<!--导航-->
			<!--位置-->
			<div v-if="infoData" class="location_box">
				<div
					data-aos="fade-left"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="location_box_main"
				>
					<span @click="goHome">首页</span>&ensp;/&ensp;<span @click="goBack">产品中心</span>&ensp;/&ensp;<span class="last">{{ infoData.name }}</span>
				</div>
			</div>
			<!--位置-->
			<!--块1-->
			<div class="block_1">
				<div v-if="infoData" class="block_1_main">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
						class="left"
					>
						<img :src="webUrl + infoData.thumb" />
						<div class="btn_box">
							<div class="btn" @click="goProduct">
								返回产品中心
							</div>
							<div class="btn" @click="goContact">
								联系我们&ensp;<van-icon name="down" size="18px" color="#C8000A" style="top: 2.5px;transform: rotate(-90deg);" />
							</div>
						</div>
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
						class="right"
					>
						<div class="cate_box">
							<div v-for="(value, index) in infoData.cate_list" :key="value.id" class="cate_el">{{ value.title }}</div>
							<div v-for="(value, index) in infoData.scenarios_list" :key="value.id" class="cate_el">{{ value.title }}</div>
						</div>
						<div class="tit">{{ infoData.name }}</div>
						<div class="desc">{{ infoData.description }}</div>
						<div v-html="infoData.content" class="content_box"></div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { UPURL } from '@/util/util';
import { productInfo, productCount } from '@/api/public'
import md5 from 'js-md5';
import moment from 'moment';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			webUrl: UPURL
		}
	},
	created(){
		let that = this;
		//请求产品详情
		if(that.$route.params.productInfoId) {
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productInfo({ id: that.$route.params.productInfoId.split('.')[0] }).then(res => {
				that.infoData = res.data;
				document.title = that.infoData.name;
				that.$toast.clear();
				//访问统计
				let time = String(moment().unix());
				setTimeout(() => {
					productCount({
						language: sessionStorage.getItem('lang'),
						productid: that.infoData.id,
						cate_id: that.infoData.cate_id,
						scenarios_id: that.infoData.scenarios_id ? that.infoData.scenarios_id : '',
						url: that.$route.name,
						addtime: time,
						sign: md5(String(that.infoData.cate_id) + String(that.infoData.scenarios_id ? that.infoData.scenarios_id : '') + String(that.infoData.id) + that.$route.name + String(time) + 'Abiores2024'),
					}).then(res => {});
				}, 10000);
			});
		}else {
			that.$toast('数据请求异常');
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goHome() {
			this.$router.push({ path: '/' });
		},
		goBack() {
			this.$router.push({ path: '/product.html' });
			// this.$router.go(-1);
		},
		goProduct() {
			this.$router.push({ path: '/product.html' });
		},
		goContact() {
			this.$router.push({ path: '/contact.html' });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//块1
	.block_1{
		background-color: #f6f6f6;
		.block_1_main{
			display: flex;
			width: 1200px;
			margin: 0 auto;
			padding-bottom: 80px;
			.right{
				flex: 1;
				padding-left: 80px;
				.content_box{
					word-break: break-all;
				}
				.desc{
					padding: 20px 0;
					font-size: 18px;
				}
				.tit{
					padding: 10px 0 0px 0;
					font-size: 30px;
					font-weight: bold;
				}
				.cate_box{
					.cate_el{
						display: inline-block;
						margin: 0 15px 15px 0;
						padding: 8px 12px;
						color: #666666;
						border: 1px solid #EEEEEE;
						border-radius: 8px;
					}
				}
			}
			.left{
				width: 450px;
				.btn_box{
					padding-top: 50px;
					text-align: center;
					.btn{
						display: inline-block;
						margin: 0 15px;
						padding: 12px 20px;
						font-size: 18px;
						border: 1px solid #C8000A;
						border-radius: 8px;
						color: #C8000A;
						cursor: pointer;
					}
				}
				img{
					width: 100%;
				}
			}
		}
	}
	//位置
	.location_box{
		background-color: #f6f6f6;
		.location_box_main{
			width: 1200px;
			margin: 0px auto;
			padding: 40px 0;
			span{
				cursor: pointer;
			}
			span.last{
				color: #999999;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .content_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box .content_box td, >>> .main_box .content_box th {
	padding: 5px;
	border: 1px solid #ddd;
}
>>> .main_box .content_box table{
	width: 100%;
	border-collapse: collapse;
}
.content_box{
	overflow: auto;
}
</style>
